export const DEBIT_CARD_ACCOUNT_TYPES = ['DDA', 'CMG', 'MMA']
